/// <reference path="../app.js"/>

class DynamicGrid {
	/**
	 * @param {JQuery<HTMLElement>} grid 
	 */
	static place(grid) {
		const maxCols = Math.max(Math.floor(Math.min(window.innerWidth, 1400) / 350), 2);

		if (maxCols === this.prevMaxCols) return;

		/** @type {boolean[][]}	*/
		const virtualGrid = [Array(maxCols).fill(false)];

		grid.children().each((_index, child) => {
			const tile = $(child);
			const rows = parseInt(tile.data("rows"));
			const cols = Math.min(parseInt(tile.data("cols")), maxCols);

			tile.css("width", (100 / maxCols) * cols + "vw");
			tile.css("height", (100 / maxCols) * rows + "vw");

			row:
			for (let y = 0; y < 128; y++) {
				if (virtualGrid.length === y) virtualGrid.push(Array(maxCols).fill(false));

				for (let x = 0; x < virtualGrid[y].length; x++) {
					let valid = true;
					let update = [];

					topRect:
					for (let xoff = 0; xoff < cols; xoff++) {
						for (let yoff = 0; yoff < rows; yoff++) {
							while (virtualGrid.length <= y + yoff) virtualGrid.push(Array(maxCols).fill(false));

							if (x + xoff === maxCols || virtualGrid[y + yoff][x + xoff] === true) {
								valid = false;
								break topRect;
							}
							else update.push({
								x: x + xoff,
								y: y + yoff
							});
						}
					}

					if (valid) {
						tile.css("transform", `translate(${(100 / maxCols) * x + "vw"}, ${(100 / maxCols) * y + "vw"})`);

						for (let {x, y} of update) virtualGrid[y][x] = true;

						break row;
					}
				}
			}
		});

		const rows = virtualGrid.filter((row) => row.reduce((_prev, curr) => _prev ? true : curr !== false)).length;
		grid.css("height", (100 / maxCols) * rows + "vw");

		this.prevMaxCols = maxCols;
	}

	static processGrids() {
		$(".DynamicGrid.element").each((_index, element) => {
			this.place($(element));
		});
	}

	static init() {
		this.prevMaxCols = 0;
		this.processGrids();

		$(window).on("resize", () => this.processGrids());
	}
}